import classNames from "classnames";
import styles from "./styles.module.scss";
import OutlinedButton from "../../../../components/common/OutlinedButton";
import {
  formatAmount,
  formatDate,
  formatTime,
} from "../../../../setup/util/wallet";
import Modal from "../../../../components/common/Modal";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";

interface IBalanceDetailsModalProps {
  title: string;
  timelineItems: any;
  type: string;
  milestoneTitle: string;
  handleClose: () => void;
  modalOpen: boolean;
  hideWithdrawTab: boolean;
}

const BalanceDetailsModal = ({
  title,
  type,
  timelineItems,
  milestoneTitle,
  modalOpen,
  handleClose,
  hideWithdrawTab,
}: IBalanceDetailsModalProps) => {
  const { t } = useTranslation();

  const fetchMessage = useCallback(
    (partyName: string) => {
      let result;

      if (type === "customer_pay") {
        result = t("balance_pay_details", {
          val: hideWithdrawTab ? partyName : "",
        });
      } else if (type === "settle") {
        result = t("balance_settle_details", { val: partyName });
      } else if (type === "cashout") {
        result = t("balance_cashout_details", { val: partyName });
      } else if (type === "org_cashout") {
        result = t("balance_org_cashout_details", { val: partyName });
      }

      return result;
    },
    [hideWithdrawTab, t, type]
  );

  return (
    <Modal
      visible={modalOpen}
      onCancel={handleClose}
      customModalClassName={styles.plan_modal_container}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "8px",
          height: "100%",
        }}>
        <h3
          style={{
            fontSize: "18px",
            lineHeight: "100%",
            fontWeight: 700,
            margin: 0,
            color: "#283743",
            marginBottom: "24px",
          }}>
          {title}
        </h3>

        <h5
          style={{
            fontSize: "15px",
            lineHeight: "100%",
            fontWeight: 500,
            margin: 0,
            color: "#283743",
          }}>
          {milestoneTitle}
        </h5>

        <div className={styles["outter_container"]}>
          <div className={styles["line_container"]} />
          <div className={styles["item_list"]}>
            {timelineItems.map((item, index) => (
              <div key={`${item?.id}-${index}`}>
                <div className={styles["item_row"]}>
                  <div className={classNames(styles["item_container"])}>
                    <div className={styles["item_title"]}>
                      <p
                        style={{
                          fontSize: "14px",
                          lineHeight: "18px",
                          fontWeight: 400,
                          color: "#555B6A",
                          margin: 0,
                        }}>
                        {fetchMessage(item?.userFullName || item?.userId || "")}
                      </p>

                      <div className={styles["thread"]} />
                    </div>
                    <div className={classNames(styles["details_container"])}>
                      {((!hideWithdrawTab && type !== "customer_pay") ||
                        hideWithdrawTab) && (
                        <p
                          className={styles["price"]}
                          style={{
                            color: item?.amount < 0 ? "red" : "",
                          }}>{`${formatAmount(item?.amount)} ${t(
                          "lbl_saudi_currency"
                        )}`}</p>
                      )}

                      {item?.date && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            gap: "6px",
                          }}>
                          <div className={styles["data_cont"]}>
                            <div className={styles["dot"]} />

                            <p className={classNames(styles["time"])}>
                              {formatDate(item?.date)}
                            </p>
                          </div>
                          <div className={styles["time_cont"]}>
                            <img
                              src="assets/images/svg/hollow-clock-circle.svg"
                              className={styles["clock_icon"]}
                              alt="clock"
                            />
                            <p className={classNames(styles["time"])}>
                              {formatTime(item?.date)}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <OutlinedButton
          onClick={handleClose}
          style={{
            marginTop: "auto",
            width: "100%",
            color: "#0D44AD",
            background: "#F3F6FC",
            border: "none",
          }}>
          {t("closed")}
        </OutlinedButton>
      </div>
    </Modal>
  );
};

export default BalanceDetailsModal;
